import { SidebarContextType } from '@/providers';
import { createContext } from 'react';

export const SidebarContext = createContext<SidebarContextType>({
  showSidebar: false,
  onChangeShowSidebar: () => {},
});
